import React from 'react';
import { Box } from '@mui/joy';

const CellSimple = ({value, type}) => {
    return <Box className={"list-element-cell cell-"+type}>{value}</Box>
}

export default CellSimple